import { getCookie } from '@atlassian/browser-storage-controls';

export type ContextToken = {
  extensionId: string;
  jwt: string;
  expiresAt: string;
};
export type FetchContextTokensResponse = ContextToken[];

const CSRF_COOKIE_NAME = 'csrftoken';
const CSRF_HEADER_NAME = 'X-CSRFToken';

export const fetchContextTokens = async ({
  appsData,
  contextIds,
  workspaceId,
  extensionContext,
}: {
  appsData: {
    extensionId: string;
    appVersion: string;
    localId: string;
  }[];
  workspaceId: string;
  contextIds: string[];
  extensionContext: object;
}): Promise<FetchContextTokensResponse> => {
  const response = await fetch(
    new Request('/!api/internal/forge/context-token', {
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        [CSRF_HEADER_NAME]: getCookie(CSRF_COOKIE_NAME) || '',
      },
      method: 'POST',
      body: JSON.stringify({
        apps_data: appsData.map(({ extensionId, appVersion, localId }) => ({
          extension_id: extensionId,
          app_version: appVersion,
          local_id: localId,
        })),
        extension_context: extensionContext,
        context_ids: contextIds,
        workspace_id: workspaceId,
      }),
    })
  );

  if (!response.ok) {
    throw new Error(
      response.statusText || 'Error while attempting to retrieve context token.'
    );
  }

  const data = await response.json();

  return data.forgeContextTokens;
};
